/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React, { useState } from "react"
import { Fields, Form2 } from "@cd2/forms"
import { titleize } from "@cd2/tools"
import { useFormSubmitLock } from "@cd2/forms/build/es6/Form2"
import { isBlank } from "@cd2/components/build/es6"
import { brandColors, themeColors } from "../EOSThemeProvider"

export function Form2TextFieldToUpperCase({
  field,
  label,
  disabled,
  required,
  maxLength,
}: {
  field: string
  label?: string
  disabled?: boolean
  required?: boolean
  maxLength?: number
}) {
  // Auto complete set to random string as "off" doesn't work for chrome, and
  // firefox bug get suggestions if the value is the same every time
  const [autoComplete] = useState<any>(Math.random().toString())
  return (
    <Form2.WithField<string>
      field={field}
      render={formField => {
        const [error, setError] = useState<string | undefined>()
        useFormSubmitLock(() => {
          if (maxLength && formField.getValue()?.length > maxLength) {
            setError(`must be less than ${maxLength} characters`)
            return false
          } else if (required && isBlank(formField.getValue())) {
            setError("is required")
            return false
          } else {
            setError(undefined)
          }
        })
        return (
          <Fields.Text
            label={
              <span>
                {label ?? titleize(field)}
                {required && (
                  <span
                    css={css`
                      color: ${brandColors.blaze};
                    `}
                  >
                    *
                  </span>
                )}
              </span>
            }
            value={formField.getValue()}
            onChange={formField.setValue}
            onBlur={() => formField.setValue((formField.getValue() ?? "").toUpperCase())}
            disabled={disabled}
            error={error || formField.getError()}
            autoComplete={autoComplete}
            inputProps={{ maxLength }}
          />
        )
      }}
      subscribe
    />
  )
}
